import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 48px 16px;
  min-height: 480px;

  svg {
    max-width: 60%;
    height: auto;
  }
`;

export const Message = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.text['sub-500']};
  text-align: center;
`;
